import { LayoutAuth } from "#/layouts/layout.auth";
import { m } from "#/paraglide/messages";
import { Card, CardContent } from "@beweegbaas/ui";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$locale/{-$schoolyear}/signup/step/success")({
  component: SignupSuccessPage,
});

function SignupSuccessPage() {
  return (
    <LayoutAuth showVisuals={false}>
      <Card className="w-full">
        <CardContent className="flex flex-col gap-4">
          <h3 className="m-0 text-3xl font-bold">{m["common.all_set"]()}</h3>
          <p>{m["signup.activation_email_sent"]()}</p>
          <p>{m["signup.trial_period_started"]()}</p>
          <img
            src="/you-got-mail-visual.svg"
            alt={m["signup.you_got_mail"]()}
            className="mx-auto mt-10 -mb-14 h-[200px] w-full"
          />
        </CardContent>
      </Card>
    </LayoutAuth>
  );
}
